import { Ref, ref, watch } from 'vue'

import { HandballAttributeId } from '@collector/sportsapi-client-legacy'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

interface UseAttributeSelection<T> {
  selectedValue: Ref<T | null>
}

export function useAttributeSelection<T>(
  linkedIncident: ProbableLinkedIncident,
  removeAttribute: (attribute: HandballAttributeId) => void,
  addAttribute: (attribute: HandballAttributeId) => void,
  attributeMap: Map<T, HandballAttributeId>,
): UseAttributeSelection<T> {
  // state
  const selectedValue = ref<T | null>(getDefaultValue()) as Ref<T | null>

  // init
  watch(selectedValue, (value) => {
    // Remove all attributes from this map
    for (const attribute of attributeMap.values()) {
      removeAttribute(attribute)
    }

    // Add the selected attribute
    const selectedAttribute = attributeMap.get(value!)
    if (selectedAttribute) {
      addAttribute(selectedAttribute)
    }
  })

  // methods
  function getDefaultValue(): T | null {
    const attributes = linkedIncident.incident.attribute_ids

    return (
      Array.from(attributeMap.entries()).find(([, attribute]) =>
        attributes.includes(attribute),
      )?.[0] ?? null
    )
  }

  return {
    selectedValue,
  }
}
